import {
  AuthenticationResult,
  Configuration,
  EventMessage,
  EventType,
  IPublicClientApplication,
  PublicClientApplication,
  RedirectRequest,
} from "@azure/msal-browser";
import featureFlags from "utils/featureFlags";

const defaultRedirectUri = "/my-insights";
const defaultPostLogoutRedirectUri = window.location.origin;

const authConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AUTH_TENANT_ID}`,
    redirectUri: defaultRedirectUri,
    postLogoutRedirectUri: defaultPostLogoutRedirectUri,
    navigateToLoginRequestUrl: false,
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ["https://graph.microsoft.com/User.Read"],
};

export const irisRequest: RedirectRequest = {
  scopes: [
    `${process.env.REACT_APP_ACCOUNT_API_APPLICATION_ID_URI}/Iris.Read`,
    `${process.env.REACT_APP_ACCOUNT_API_APPLICATION_ID_URI}/Iris.Write`,
  ],
};

export const remitRequest: RedirectRequest = {
  scopes: [
    `${process.env.REACT_APP_ACCOUNT_API_APPLICATION_ID_URI}/Remit.Submit`,
  ],
};

export const REMIT_SUBMIT_ROLE = "Remit.Submit.Role";

const decodeBase64Url = (str: string): Record<string, unknown> => {
  let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4) base64 += "=";
  return JSON.parse(window.atob(base64));
};

export const parseRolesFromAccessToken = (accessToken: string): string[] => {
  try {
    const decoded = decodeBase64Url(accessToken.split(".")[1]);
    const roles = decoded.roles;
    return Array.isArray(roles) ? (roles as string[]) : [];
  } catch {
    return [];
  }
};

export const initialiseAuth = (): IPublicClientApplication => {
  const authContext = new PublicClientApplication(authConfig);

  // User should never be able to sign in with more than one account because there is no login button
  // if they're already logged in.
  const accounts = authContext.getAllAccounts();
  if (accounts.length > 0) {
    authContext.setActiveAccount(accounts[0]);
  }

  authContext.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const { account } = payload;
      authContext.setActiveAccount(account);
    }
  });

  return authContext;
};
export const authContext = featureFlags.accountArea
  ? initialiseAuth()
  : undefined;
